import { render, staticRenderFns } from "./PinTuan.vue?vue&type=template&id=5b02ebbe&"
import script from "./PinTuan.vue?vue&type=script&lang=js&"
export * from "./PinTuan.vue?vue&type=script&lang=js&"
import style0 from "./PinTuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports